import { Component } from '@angular/core';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-optimistic-lock-modal',
  templateUrl: './optimistic-lock-modal.component.html',
  styleUrls: ['./optimistic-lock-modal.component.scss'],
  imports: [TranslatePipe, NgbTooltip]
})
export class OptimisticLockModalComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
